 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MarketingEffortAddEdit',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('#marketingeffortaddedit-effort_type').on('change', function effortTypeChange(e) {
			var effort_type = $(this).val();

			switch (effort_type) {
				case 'new':
					showCreateEffortFields();
					break;
				case 'global':
					showGlobalEfforts();
					break;
				default:
					// nothing
			}
		});

		$('#marketingeffortaddedit-global_efforts').on('change', function selectGlobalEffort(e) {
			var effort_id = $(this).val();

			if (effort_id) {
				Adzuki.Ajax.get('/MarketingEfforts/details/' + effort_id)
				.then(function setEffortDetails(response) {
					$('#marketingeffortaddedit-name').val(response.name);
					$('#marketingeffortaddedit-description').val(response.description);

					$('.effort-field').removeClass('hidden');
				});
			} else {
				clearEffortFields();
			}
		});

		$('#marketingeffortaddedit-start_date').on('dp.change', function dateChange(e) {
			var start_date = e.date,
			    end_date   = $('#marketingeffortaddedit-end_date').data('DateTimePicker');

			// if the start date is greater than the end date
			// if the end date element is blank, or has never been interacted with, it may be null, so check that too
			if (end_date.date() !== null && end_date.date().isBefore(start_date) === true) {
				// set the end_date to the start_date in this case
				end_date.date(start_date);
			}
		});

		$('#marketingeffortaddedit-vendor_coop').change(function coopChanged() {
			var vendor_coop_id = $(this).val();

			if (vendor_coop_id === '') {
				$('.coop-description').addClass('hidden');
				$('.coop-amount').addClass('hidden');
				$('.coop-description').val('');
				$('.coop-amount').val('');
			} else {
				$('.coop-description').removeClass('hidden');
				$('.coop-amount').removeClass('hidden');
			}
		});
	};

	function showCreateEffortFields()
	{
		$('#marketingeffortaddedit-global_efforts').val('');
		clearEffortFields();
		$('#global-efforts-row').addClass('hidden');
		$('.effort-field').removeClass('hidden');
	}

	function showGlobalEfforts()
	{
		$('.effort-field').addClass('hidden');
		$('#global-efforts-row').removeClass('hidden');
	}

	function clearEffortFields()
	{
		$('.effort-field input, .effort-field textarea, .effort-field select').each(function clearField(index, el) {
			if (!$(el).hasClass('dropped_count')) {
				$(el).val('');
			}
		});
	}

}(jQuery, window.Adzuki || {}));
